var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 2.375C5.45304 2.375 2.375 5.45304 2.375 9.25C2.375 13.047 5.45304 16.125 9.25 16.125C11.1487 16.125 12.8662 15.3565 14.1114 14.1114C15.3565 12.8662 16.125 11.1487 16.125 9.25C16.125 5.45304 13.047 2.375 9.25 2.375ZM0.5 9.25C0.5 4.41751 4.41751 0.5 9.25 0.5C14.0825 0.5 18 4.41751 18 9.25C18 11.3282 17.2746 13.2382 16.0647 14.7388L20.2254 18.8996C20.5915 19.2657 20.5915 19.8593 20.2254 20.2254C19.8593 20.5915 19.2657 20.5915 18.8996 20.2254L14.7388 16.0647C13.2382 17.2746 11.3282 18 9.25 18C4.41751 18 0.5 14.0825 0.5 9.25Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSee);
export default __webpack_public_path__ + "static/media/see.9699a850ecaeaabb77eef1b6cb70905a.svg";
export { ForwardRef as ReactComponent };